import point from "../point";
import line from "../line";
import config from "../../../store/sqftConfig";

const RECTANGLE_WIDTH = 150;
const RECTANGLE_HEIGHT = 26;
const RECTANGLE_HEIGHT_METRIC = 23.62;

export default function(rectangleWidth = RECTANGLE_WIDTH, rectangleHeight = 0) {
  let points;
  if (rectangleHeight === 0) {
    rectangleHeight = config.measureUnit === "Imperial" ? RECTANGLE_HEIGHT : RECTANGLE_HEIGHT_METRIC;
  }

  points = [
    new point(0, 0, "lefttop"),
    new point(rectangleWidth, 0, "righttop"),
    new point(rectangleWidth, rectangleHeight, "rightbottom"),
    new point(0, rectangleHeight, "leftbottom")
  ];

  return [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[0])
  ];
}
